import { ReactNode } from 'react';
import { Link } from 'react-router-dom';

import { SvgIconComponent } from '@mui/icons-material/index.d';
import { Paper, Typography } from '@mui/material';

import styled from 'styled-components';

import { Constants } from '@arrived/common';

import { GradientIcon } from '../images';

const StyledLink = styled.a`
  text-decoration: none;
`;

const StyledPaper = styled(Paper)`
  &.option-card {
    display: flex;
    align-items: center;
    gap: ${({ theme }) => theme.spacing(2)};
    height: 100%;
    padding: ${({ theme }) => theme.spacing(3)};

    .icon-container {
      padding: ${({ theme }) => theme.spacing(3)};
      background: ${({ theme }) => theme.palette.lightened.iceBlue};
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;

      .option-icon {
        width: 30px;
        height: 30px;
      }
    }

    &:hover {
      box-shadow: ${({ theme }) => theme.shadows[4]};

      .icon-container {
        background: ${({ theme }) => theme.gradients.sea.horizontal};

        .option-icon {
          fill: ${({ theme }) => theme.palette.neutrals.white};
        }
      }
    }
  }
`;

export interface OptionCardProps {
  icon: SvgIconComponent;
  path: string;
  title: ReactNode;
  subTitle: ReactNode;
  external?: boolean;
}

export const OptionCard = ({ icon, path, title, subTitle, external }: OptionCardProps) => {
  const cardContent = (
    <StyledPaper className="option-card" square elevation={0}>
      <div className="icon-container">
        <GradientIcon className="option-icon" Icon={icon} />
      </div>
      <div className="text-container">
        <Typography variant="h6.semibold">{title}</Typography>
        <Typography variant="body2">{subTitle}</Typography>
      </div>
    </StyledPaper>
  );

  if (external) {
    return <StyledLink href={path}>{cardContent}</StyledLink>;
  }

  return (
    <StyledLink as={Link} to={path}>
      {cardContent}
    </StyledLink>
  );
};
